export const ACTION_PLAN_MAX_DECISION_OUTPUTS = 15;

export const canAddActionPlanDecisionOutput = (outputCount) =>
  outputCount < ACTION_PLAN_MAX_DECISION_OUTPUTS;
